// import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';

//MUI
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, keyframes } from '@mui/material/styles';

//Our Imports
import { imageExist } from '../../../assets/js/init';
import introImg from '../../../assets/img/common/introImg.png';
import { CustomButton } from '../../../assets/component/initComponent';
import { GraphPulseWord } from '../../../assets/component/GraphPulseWord';
// import { useLenis } from '../../../ScrollLenisProvider';

const Intro = ({ viewOnce = true, scrollToSection }) => { //setReached

	const theme    = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('lg')); 

	// const buttonRef = useRef(null);
	// const [isNav, setIsNav] = useState(false);
	// const [startAni, setStartAni] = useState(false);
	// const [triggerPoint, setTriggerPoint] = useState(0);
	// const lenis = useLenis();

	// useEffect(() => {
	// 	if (!buttonRef.current) return;

	// 	const rect = buttonRef.current.getBoundingClientRect();
	// 	const scrollTop = window.scrollY || document.documentElement.scrollTop;

	// 	setTriggerPoint(rect.top + scrollTop);
	// }, []);

	// const buttonRef = useRef(null);
	// const [isNav, setIsNav] = useState(false);

	// const lenis = useLenis();

	// const scrollToDemo = (e) => {
	// 	e.preventDefault(); // stop default anchor jump

	// 	if (!lenis) return;

	// 	lenis.scrollTo('#demo', {
	// 		duration: 2,
	// 		easing: (t) => 1 - Math.pow(1 - t, 4),
	// 		onComplete: () => {
	// 			setReached(true);
	// 		}
	// 	});
	// };

	// keyframes for vertical scroll
	const scrollAnim = keyframes`
		0% { transform: translateY(0); }
		50% { transform: translateY(-30%); }
		100% { transform: translateY(0); }
	`;

	// useEffect(() => {
	// 	if (!lenis || !buttonRef.current) return;

	// 	const onScroll = () => {
	// 		const rect = buttonRef.current.getBoundingClientRect();

	// 		if (rect.top <= 0) {
	// 			setIsNav(true);
	// 		} else {
	// 			setIsNav(false);
	// 		}
	// 	};

	// 	lenis.on('scroll', onScroll);

	// 	return () => {
	// 		lenis.off('scroll', onScroll);
	// 	};
	// }, [lenis]);

	// useEffect(() => {
	// 	if (!lenis) return;

	// 	const handleScroll = ({ scroll }) => {
	// 		if (scroll >= triggerPoint) {
	// 			setIsNav(true);
	// 		} else {
	// 			setIsNav(false);
	// 		}
	// 	};

	// 	lenis.on('scroll', handleScroll);

	// 	return () => {
	// 		lenis.off('scroll', handleScroll);
	// 	};
	// }, [lenis, triggerPoint]);

	//MOBILE FRAME
	const MobileFrame = ({ src }) => {
		return (
			<Box sx={{ position: 'relative' }}>
				<Box
					sx={{
						width: '250px',
						height: '550px',
						borderRadius: '36px',
						border: '8px solid #000',
						position: 'relative',
						background: '#000',
						overflow: 'hidden', // show only inside frame
						boxShadow: isMobile ? '' : '90px 50px 25px rgba(0,0,0,0.3)',
						zIndex: 10
					}}
				>
					{/* notch */}
					<Box
						sx={{
							position: 'absolute',
							top: 4,
							left: '50%',
							transform: 'translateX(-50%)',
							width: 60,
							height: 14,
							background: '#000',
							borderRadius: '7px',
							zIndex: 2,
							display: 'flex',
							justifyContent: 'flex-end',
							alignItems: 'center',
							paddingRight: '5px'
						}}
					>
						<Box sx={{ height: '8px', width: '8px', background: 'gray', borderRadius: '50%' }}/>
					</Box>
					{/* long image auto-scrolling */}
					<Box
						component='img'
						src={src}
						alt='scrolling'
						sx={{
							width: '100%',       // fit width
							height: 'auto',      // keep original long height
							position: 'absolute',
							top: 0,
							left: 0,
							animation: `${scrollAnim} 20s linear infinite` // duration & loop
						}}
					/>
				</Box>
				{/* side buttons (right side) */}
				<Box
					sx={{
						position: 'absolute',
						top: '100px',
						right: '-3px',
						width: '4px',
						height: '30px',
						backgroundColor:'#000',
						borderRadius: '20px'
					}}
				/>
				<Box
					sx={{
						position: 'absolute',
						top: '150px',
						right: '-3px',
						width: '4px',
						height: '60px',
						background: '#000',
						borderRadius: '20px'
					}}
				/>
			</Box>
		);
	};

	const textVariant = {
		hidden: {
			opacity: 0,
			x: -140
			// scale: 0.5
		},
		visible: {
			opacity: 1,
			x: 0,
			// scale: 1,
			transition: {
				duration: 2,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	const mobVariant = {
		hidden: {
			opacity: 0,
			x: -140
			// scale: 0.5
		},
		visible: {
			opacity: 1,
			x: 0,
			transition: {
				delay: 0.5,
				duration: 1,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	return (
		<Container className='containerFull'>
			<Grid container alignItems='center' rowSpacing={3}> 
				<Grid size={{ lg: 7, md: 7, sm: 12, xs: 12 }}>
					<motion.div
						variants={textVariant}
						initial='hidden'
						whileInView='visible'
						viewport={{ once: viewOnce, margin: '-100px' }}
					>
						<Box className='textCl' sx={{ textAlign: { xs: 'center', lg: 'left', md: 'left' } }}>
							{/* Intro Title - Start */}
							<Typography variant='h1' component='h1' className='visuallyHidden'>
								Online Financial Calculators for SIP, EMI & Investment Planning in India
							</Typography>
							<Typography variant='h1' component='p' className='font60'>
								<Typography component='span' className='font30 fontBold'>Introducing Artha</Typography>
								<Typography component='span' display='block' className='fontBolder'>The Ultimate</Typography>
								<Typography component='span' display='block' className='fontBolder'>Financial Calculator</Typography>
								<Typography component='span' className='fontBolder' sx={{ display: 'flex', alignItems: 'center', justifyContent: { md: 'flex-start', sm: 'center', xs: 'center' }, gap: 2 }}>
									To Build
									<GraphPulseWord
										words={['Wealth', 'Growth', 'Finance']}
										reveal={500}
										pause={2000}
										hide={200}
										className='fontBolder primaryCl font60'
									/>
								</Typography>
							</Typography>
							{/* Intro Title - End */}
							
							<Stack direction={'row'} spacing={1} className='hideInMbl' alignItems='center' justifyContent='center' p='30px 0px'>
								<Grid size={{ lg: 7, md: 7, sm: 6, xs: 10 }}>
									<CustomButton onClick={(e) => scrollToSection(e, '#demo')}>Explore Our Short Demo</CustomButton>
								</Grid>
								{/* {isNav && <div style={{ height: "70px" }} />}
								<div
								ref={buttonRef}
								className={`floating-btn ${isNav ? "as-nav" : ""}`}
								>
								{isNav ? (
									<>
									<span>Logo</span>
									<span>About</span>
									<span>Services</span>
									<span>Contact</span>
									</>
									) : (
										<Box sx={{ border: '' }}>Explore</Box>
										)}
										</div> */}
								{/* <Box ref={buttonRef} className={`whiteCl fontBold floating-btn ${isNav ? "as-nav" : ""}`} sx={{ bgcolor: '#5B31A1', py: '15px', px: '30px', borderRadius: '12px', whiteSpace: 'nowrap' }}>Explore Our Short Demo</Box> */}
								<Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}>
									{imageExist({
										required: '/common',
										url: '/introArrow.svg',
										alt: 'introArrow',
										width: '100%',
										className: 'hideInMbl'
									})}
								</Box>
							</Stack>
						</Box>
					</motion.div>
				</Grid>
				<Grid size={{ lg: 5, md: 5, sm: 12, xs: 12 }} sx={{ justifyItems: { lg: 'center' } }}>
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: { lg:'-70px',xs:0 } }}>
						<motion.div
							variants={mobVariant}
							initial='hidden'
							whileInView='visible'
							viewport={{ once: viewOnce, margin: '-100px' }}
						>
							<MobileFrame src={introImg}/>
						</motion.div>
					</Box>
					<Box mt='20px' sx={{ display: { xs: 'block', sm: 'none', md: 'none', justifyItems: 'center' } }}>
						<Grid size={9}>
							<CustomButton>Get Started For Free</CustomButton>
						</Grid>
					</Box>
				</Grid>
			</Grid>
		</Container>
	);
};

export default Intro;
